import APIError from '../errors/APIError';
import { IDeliveryFee } from '../models/DeliveryFee';

import api from './api';


const importProducts = async (empresa_id: number, file: any): Promise<boolean> => {
  try {
    const formData = new FormData();

    formData.append('planilha', file);
    formData.append('empresa_id', empresa_id.toString());

    const response = await api.post('/grupo/planilha', formData, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    const parsedError = error as any;

    let errorMessage = parsedError?.response?.data?.message;

    if (!errorMessage) {
      errorMessage = 'Erro ao realizar importação por planilha';
    }

    throw new APIError(errorMessage);
  }
}

export default importProducts;
